import React from 'react';
import './About.css';

function About () {
  return (
    <section id="about" className="about-section">
      <div className="about-left">
        <h1>About Me</h1>
         <p className="about-intro">
          I’m Mary Grace Benbenuto — a fresh graduate with a passion for blending technology, creativity, and people-centered solutions.

I thrive in spaces where I can learn, adapt, and grow, whether that’s in digital marketing, design, or tech. What drives me is the opportunity to create meaningful work that connects with people and makes a difference, no matter how big or small.

I see myself as someone who’s curious, resourceful, and committed to growth — always eager to explore new ideas, take on challenges, and build skills that help me contribute value to any team I’m part of.
        </p>
        <div className="personal-qualities">
          <div className="quality-badge">Team Player</div>
          <div className="quality-badge">Detail-Oriented</div>
          <div className="quality-badge">Adaptable</div>
          <div className="quality-badge">Creative Thinker</div>
          <div className="quality-badge">Fast Learner</div>
        </div>

        <div className="about-star">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#ffb515"
    viewBox="0 0 24 24"
    width="50"
    height="50"
  >
    <path d="M12 .587l3.668 7.431 8.2 1.193-5.934 5.782 1.4 8.174L12 18.896l-7.334 3.86 1.4-8.174L.132 9.21l8.2-1.193L12 .587z" />
  </svg>
</div>


      </div>
    </section>
  );
};

export default About;
